"use client";

import React, { useState } from "react";
import { Search } from "lucide-react";

import { Input } from "../../components/ui/input";
import { cn } from "../../lib/utils";
import SearchIcon from "@mui/icons-material/Search";

export function SearchInput({ className, onSearch, placeholder = "", ...props }) {
  const [value, setValue] = useState("");

  const handleChange = (e) => {
    const newValue = e.target.value;
    setValue(newValue);
    if (onSearch) {
      onSearch(newValue);
    }
  };

  return (
    <div className={cn("relative", className)}>
      {/* <Search className="absolute left-2.5 top-2.5 h-5 w-4 text-gray-500"  size={20}/> */}
      <SearchIcon className="absolute left-3 top-3 h-5 w-5 text-gray-400 mr-4" />
      <Input
        className="pl-11 h-[45px] bg-[#F4F4F4] rounded-[8px] shadow-none flex items-center border-0 text-base"
        type="search"
        placeholder={`Search by ${placeholder}`}
        value={value}
        onChange={handleChange}
        {...props}
      />
    </div>
  );
}
